import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { watchEffect } from 'vue'
import translate from 'src/common/helpers/language/translate'
import translationObject from './translate/baseFileUploader.translate'
import _ from 'lodash'

interface IProps {
  translateObject?: Record<string, string>
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseUploader', inheritAttrs: false },
  __name: 'BaseFileUploader',
  props: {
    translateObject: { default: () => ({}) }
  },
  setup(__props: any) {


const props = __props

const { t } = translate(translationObject)

let textObject = {
  image: {
    single_upload: t('image.single_upload'),
    multiple_upload: t('image.multiple_upload'),
    replace: t('image.replace'),
    hint: t('image.hint'),
    error: t('image.hint'),
    alert: t('image.alert'),
  },
  video: {
    single_upload: t('video.single_upload'),
    replace: t('video.replace'),
    hint: t('video.hint'),
    error: t('video.error'),
  },
}

watchEffect(() => {
  textObject = _.merge(textObject, props.translateObject)
})

return (_ctx: any,_cache: any) => {
  const _component_k_file_uploader = _resolveComponent("k-file-uploader")!

  return (_openBlock(), _createBlock(_component_k_file_uploader, _mergeProps({ text: _unref(textObject) }, _ctx.$attrs), null, 16, ["text"]))
}
}

})